export default "__VITE_PUBLIC_ASSET__61afb8ab__"